import {
  DataGrid,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Box, Button, darken, Grid, lighten, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { dataGridRoTextConstants } from "../../../constants/dataGridRoTextConstants";
import AddUserDialog from "../../dialogs/users/AddUserDialog";
import EditUserDialog from "../../dialogs/users/EditUserDialog";
import DeleteRowDialog from "../../dialogs/DeleteRowDialog";
import {
  getBirthdate,
  getEmail,
  getFirstName,
  getLastName,
  getRole,
  getUsername,
  getPhone,
} from "../../../functions/valueGetterFunctions/userGetterFunctions";
import { userRequest } from "../../../api/UserRequest";
import { useSelector } from "react-redux";
import { isAdminSelector } from "../../../redux/slice/selectors";

const getBackgroundColor = (color: string, mode: string) =>
  mode === "dark" ? darken(color, 0.6) : lighten(color, 0.6);

const getHoverBackgroundColor = (color: string, mode: string) =>
  mode === "dark" ? darken(color, 0.5) : lighten(color, 0.5);

export default function UsersDataGrid() {
  const isAdmin = useSelector(isAdminSelector);
  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 90, flex: 1, hide: true },
    {
      field: "username",
      headerName: "Utilizator",
      width: 150,
      flex: 1,
      valueGetter: getUsername,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      flex: 1,
      valueGetter: getEmail,
    },
    {
      field: "role",
      headerName: "Rol",
      width: 160,
      flex: 1,
      valueGetter: getRole,
    },
    {
      field: "lastName",
      headerName: "Nume",
      width: 150,
      flex: 1,
      valueGetter: getLastName,
    },
    {
      field: "firstName",
      headerName: "Prenume",
      width: 150,
      flex: 1,
      valueGetter: getFirstName,
    },
    {
      field: "phone",
      headerName: "Telefon",
      width: 150,
      flex: 1,
      valueGetter: getPhone,
    },
    {
      field: "birthdate",
      headerName: "Data nașterii",
      type: "date",
      width: 160,
      flex: 1,
      valueGetter: getBirthdate,
    },
    // {
    //   field: "actions",
    //   headerName: "Acțiuni",
    //   minWidth: 90,
    //   maxWidth: 90,
    //   filterable: false,
    //   renderCell: ({ row: user }) => {
    //     return [
    //       <IconButton>
    //         <EditIcon
    //           fontSize="small"
    //           color="warning"
    //           onClick={() => {
    //             handleOpenEditUserDialog(user);
    //           }}
    //         />
    //       </IconButton>,
    //       <IconButton>
    //         <DeleteIcon
    //           fontSize="small"
    //           color="error"
    //           onClick={() => handleOpenDeleteRowDialog(user.id)}
    //         />
    //       </IconButton>,
    //     ];
    //   },
    // },
  ];

  isAdmin &&
    columns.push({
      field: "actions",
      headerName: "Acțiuni",
      minWidth: 90,
      maxWidth: 90,
      filterable: false,
      renderCell: ({ row: user }) => {
        return [
          <IconButton>
            <EditIcon
              fontSize="small"
              color="warning"
              onClick={() => {
                handleOpenEditUserDialog(user);
              }}
            />
          </IconButton>,
          <IconButton>
            <DeleteIcon
              fontSize="small"
              color="error"
              onClick={() => handleOpenDeleteRowDialog(user.id)}
            />
          </IconButton>,
        ];
      },
    });

  const [pageSize, setPageSize] = React.useState<number>(10);
  const [rows, setRows] = useState<User[]>([]);

  const fetchUsers = () => {
    userRequest.findAll().then((data) => {
      setRows(
        data.results.map((user: User) => ({
          id: user.id,
          username: user.username,
          email: user.email,
          password: user.password,
          firstName: user.firstName,
          lastName: user.lastName,
          birthdate: user.birthdate,
          phone: user.phone,
          role: user.role,
        }))
      );
    });
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const [selectedUserForEdit, setSelectedUserForEdit] = useState<
    User | undefined
  >(undefined);

  const [openAddUserDialog, setOpenAddUserDialog] = React.useState(false);
  const handleOpenAddUserDialog = () => {
    setOpenAddUserDialog(true);
  };

  const [openEditUserDialog, setOpenEditUserDialog] = React.useState(false);
  const handleOpenEditUserDialog = (user: User) => {
    setOpenEditUserDialog(true);
    setSelectedUserForEdit(user);
  };

  const [toBeDeleted, setToBeDeleted] = React.useState<number | null>(null);
  const handleOpenDeleteRowDialog = (id: any) => {
    setToBeDeleted(id);
  };
  const handleCloseDeleteRowDialog = () => {
    setToBeDeleted(null);
  };
  const openDeleteRowDialog = Boolean(toBeDeleted);

  const [filterButtonEl, setFilterButtonEl] = React.useState(null);

  const CustomToolbar = React.useCallback(() => {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          <Grid
            item
            sx={{
              ml: 1,
            }}
          >
            <GridToolbarQuickFilter />
          </Grid>
          <Grid
            item
            sx={{
              mr: 0.3,
            }}
          >
            <Grid container direction="row" spacing={1}>
              <Grid item>
                <Button size="small" onClick={handleOpenAddUserDialog}>
                  <Stack direction="row">
                    <AddIcon
                      fontSize="small"
                      sx={{
                        mr: 1,
                      }}
                    />
                    Adaugă utilizator
                  </Stack>
                </Button>
              </Grid>
              <Grid item>
                {/* @ts-ignore */}
                <GridToolbarFilterButton ref={setFilterButtonEl} />
              </Grid>
              <Grid item>
                {/* @ts-ignore */}
                <GridToolbarColumnsButton ref={setFilterButtonEl} />
              </Grid>
              <Grid item>
                {/* @ts-ignore */}
                <GridToolbarDensitySelector ref={setFilterButtonEl} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </GridToolbarContainer>
    );
  }, []);

  return (
    <Box
      sx={{
        height: 400,
        width: "100%",
        "& .super-app-theme--Open": {
          bgcolor: (theme) =>
            getBackgroundColor(theme.palette.info.main, theme.palette.mode),
          "&:hover": {
            bgcolor: (theme) =>
              getHoverBackgroundColor(
                theme.palette.info.main,
                theme.palette.mode
              ),
          },
        },
        "& .super-app-theme--Filled": {
          bgcolor: (theme) =>
            getBackgroundColor(theme.palette.success.main, theme.palette.mode),
          "&:hover": {
            bgcolor: (theme) =>
              getHoverBackgroundColor(
                theme.palette.success.main,
                theme.palette.mode
              ),
          },
        },
        "& .super-app-theme--PartiallyFilled": {
          bgcolor: (theme) =>
            getBackgroundColor(theme.palette.warning.main, theme.palette.mode),
          "&:hover": {
            bgcolor: (theme) =>
              getHoverBackgroundColor(
                theme.palette.warning.main,
                theme.palette.mode
              ),
          },
        },
        "& .super-app-theme--Rejected": {
          bgcolor: (theme) =>
            getBackgroundColor(theme.palette.error.main, theme.palette.mode),
          "&:hover": {
            bgcolor: (theme) =>
              getHoverBackgroundColor(
                theme.palette.error.main,
                theme.palette.mode
              ),
          },
        },
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="flex-end"
        spacing={1}
      >
        <Grid item xs={12}>
          <div style={{ width: "100%" }}>
            <div style={{ display: "flex", height: "100%" }}>
              <div style={{ flexGrow: 1 }}>
                <DataGrid
                  rows={rows}
                  getRowId={(row) => row.id}
                  columns={columns}
                  initialState={{
                    sorting: {
                      sortModel: [{ field: "id", sort: "desc" }],
                    },
                  }}
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  autoHeight
                  pagination
                  disableSelectionOnClick
                  checkboxSelection={false}
                  experimentalFeatures={{ newEditingApi: true }}
                  localeText={dataGridRoTextConstants}
                  components={{ Toolbar: CustomToolbar }}
                  componentsProps={{
                    pagination: {
                      labelRowsPerPage: "Număr de înregistrări pe pagină",
                    },
                    panel: {
                      anchorEl: filterButtonEl,
                      placement: "bottom-end",
                    },
                  }}
                  getRowClassName={(params) =>
                    `super-app-theme--${params.row.status}`
                  }
                  sx={{
                    "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within":
                      {
                        outline: "none",
                      },

                    "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus":
                      {
                        outline: "none",
                      },
                  }}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      {openAddUserDialog && (
        <AddUserDialog
          open={openAddUserDialog}
          onUserCreated={fetchUsers}
          onClose={() => {
            setOpenAddUserDialog(false);
          }}
        />
      )}
      {openEditUserDialog && (
        <EditUserDialog
          open={openEditUserDialog}
          user={selectedUserForEdit}
          onUserEdited={fetchUsers}
          onClose={() => {
            setOpenEditUserDialog(false);
            setSelectedUserForEdit(undefined);
          }}
        />
      )}
      {openDeleteRowDialog && (
        <DeleteRowDialog
          open={openDeleteRowDialog}
          onClose={handleCloseDeleteRowDialog}
          onDelete={() => {
            if (toBeDeleted) {
              userRequest
                .delete(toBeDeleted)
                .then(fetchUsers)
                .catch(() =>
                  alert(
                    "S-a produs o eroare! Este posibil ca înregistrarea aleasă să fie asociată cu alte tipuri de înregistrări și nu este permisă ștergerea!"
                  )
                );
            }
          }}
        />
      )}
    </Box>
  );
}
